<!-- 配送地管理二级 -->
<template>
	<div class="saleCustomerManagement">
		<div class="public_Spacing customerManagementPC">
			<div class="pulbic_oparetionBlock">
				<div class="public_criteriaRange customerManagementPC-select">
					<div class="public_oparetionBlock_Menu salesDeliveryPlace-input">
						<label class="public_lbSty" style="width: 110px;">配送地名称：</label>
						<input type="text" v-model="deliveryPlaceNameQuery" />
						<!-- <el-select class="public_optionSty dropDown_Define" v-model="deliveryPlaceNameQuery" filterable>
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select> -->
					</div>
					
					
				</div>
				<div class="customerManagementPC-btn public_operatBtn" style="margin-left: 0px;">
					
					<el-button class="public_saleWater_chaxun" type="primary"  @click="conditionsQuery" v-shiroHiden="solelist" id="查询">
						<i class="iconfont icon-chaxun"></i>查询
					</el-button>
					<el-button class="public_saleWater_xinzeng" type="primary"   @click="deliveryPlaceAdd" v-shiroHiden="solelist" id="新增">
						<i class="iconfont icon-tianjia1"></i>新增
					</el-button>
				</div>
			</div>
			<div class="customerManagementPC-table pulbic_oparetionBlock pulbic_table_container">
				<el-table :data="DPList" style="width: 100%" max-height="100%" stripe class="public_tableColumn" :default-sort="{prop: 'waterNum', order: 'descending'}"
				 :header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}">
				<el-table-column prop='ORMTB414CA00' label="配送地"></el-table-column>
				<el-table-column prop='ORMTB414CA01' label="运费"></el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<div class="customerManagementPC-table-btn">
								<el-button type="primary" class="public_icon_xiugai public_icon_width" v-shiroHiden="solelist" id="修改" size="small" @click="DPModifyClick(scope.row)">修改</el-button>
								<el-button class="public_icon_jinyong public_icon_margin public_icon_width" type="danger" v-shiroHiden="solelist" id="删除" size="small" @click="DPDelClick(scope.row)">删除</el-button>
								<el-button type="primary" class="public_icon_qiyong public_icon_width" size="small" v-shiroHiden="solelist" id="配送工地管理" @click="deliverySiteClick(scope.row)">配送工地管理</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="customerManagementPC-page">
					<el-pagination size-change="CarhandleSizeChange" @size-change="DPhandleSizeChange" @current-change="DPhandleCurrentChange"
					 :current-page.sync="DPpage" :page-sizes="[10, 20, 30, 40]" layout="total, sizes,prev, pager, next, jumper" :page-size="DPpagesize"
					 :total="DPcount"></el-pagination>
				</div>
			</div>
			<!-- 配送地新增 -->
			<div class="public-dialog">
				<el-dialog title="新增配送地" :visible.sync="deliveryPlAddDialog" width="30%" :closeOnClickModal='false' append-to-body custom-class="sales-delivery-place-dialog">
					<div class="customerManagementPC-add-customer">
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">配送地:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="DPNameAdd" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">运费:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input style="width: 80%;" type="text" v-model="DPFreightAdd" @keyup="DPFreightAddUp"/>元/吨
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<!-- <div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">备注:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="DPRemarksAdd" />
							</div>
							<div  class="customerManagementPC-add-customer-li-type"></div>
						</div> -->
						<div class="customerManagementPC-add-customer-btn">
							<el-button type="primary" @click="deliveryPlAddSave">保存</el-button>
							<el-button type="info" @click="deliveryPlAddDialog=false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 配送地修改 -->
			<div class="public-dialog">
				<el-dialog title="修改配送地" :visible.sync="deliveryPlModifyDialog" width="30%"  :closeOnClickModal='false' append-to-body custom-class="sales-delivery-place-dialog">
					<div class="customerManagementPC-add-customer">
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">配送地:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="DPNameModify" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">运费:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input style="width: 80%;" type="text" v-model="DPFreightModify" @keyup="DPFreightModifyUp"/>元/吨
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<!-- <div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">备注:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="DPRemarksModify" />
							</div>
							<div  class="customerManagementPC-add-customer-li-type"></div>
						</div> -->
						<div class="customerManagementPC-add-customer-btn">
							<el-button type="primary" @click="deliveryPlModifySave">保存</el-button>
							<el-button type="info" @click="deliveryPlModifyDialog=false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!--  -->
			<!-- 配送工地管理 -->
			<div class="public-dialog">
				<el-dialog title="配送工地管理" :visible.sync="deliverySiteDialog" width="75%" :closeOnClickModal='false' append-to-body custom-class="sales-delivery-place-dialog">
					<div class="customerManagementPC-btn public_operatBtn" style="margin-left: 0px;">
						<el-button class="public_saleWater_xinzeng" type="primary" @click="deliverySiteAdd">
							<i class="iconfont icon-tianjia1"></i>新增
						</el-button>
					</div>
					<el-table :border="false" :data="DSList" style="width: 100%" max-height="100%" stripe class="public_tableColumn"
					 :default-sort="{prop: 'waterNum', order: 'descending'}" :header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}">
						<el-table-column prop='ORMTB415CA00' label="配送工地名称"></el-table-column>
						<el-table-column prop='ORMTB415CA01' label="运费"></el-table-column>
						<el-table-column prop='ORMTB415CA02' label="联系人"></el-table-column>
						<el-table-column prop='ORMTB415CA03' label="联系电话"></el-table-column>
						<el-table-column prop='ORMTB415CA04' label="备注"></el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<div class="customerManagementPC-table-btn">
									<el-button type="primary" class="public_icon_xiugai public_icon_width" size="small" @click="DSModifyClick(scope.row)">修改</el-button>
									<el-button class="public_icon_jinyong public_icon_margin public_icon_width" type="danger" size="small" @click="DSDelClick(scope.row)">删除</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
					<div class="customerManagementPC-page">
						<el-pagination size-change="CarhandleSizeChange" @size-change="DShandleSizeChange" @current-change="DShandleCurrentChange"
						 :current-page.sync="DSpage" :page-sizes="[10, 20, 30, 40]" layout="total, sizes,prev, pager, next, jumper" :page-size="DSpagesize"
						 :total="DScount"></el-pagination>
					</div>
				</el-dialog>
			</div>
			<!-- 配送工地新增 -->
			<div class="public-dialog">
				<el-dialog title="新增配送工地" :visible.sync="deliverySiAddDialog" width="30%"  :closeOnClickModal='false' append-to-body custom-class="sales-delivery-place-dialog">
					<div class="customerManagementPC-add-customer">
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">配送地:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="DSNameAdd" readonly />
							</div>
							<div class="customerManagementPC-add-customer-li-type"></div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">配送工地:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="DSDeliveryAdd"/>
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">运费:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input style="width: 80%;" type="text" v-model="DSFreightAdd" @keyup="DSFreightAddUp"/>元/吨
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">联系人:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="DSContactsAdd"  />
							</div>
							<div class="customerManagementPC-add-customer-li-type"></div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">联系方式:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="DSPhoneAdd"  />
							</div>
							<div class="customerManagementPC-add-customer-li-type"></div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">备注:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="DSRemarksAdd" />
							</div>
							<div  class="customerManagementPC-add-customer-li-type"></div>
						</div>
						<div class="customerManagementPC-add-customer-btn">
							<el-button type="primary" @click="deliverySiAddSave">保存</el-button>
							<el-button type="info" @click="deliverySiAddDialog=false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 配送工地修改 -->
			<div class="public-dialog">
				<el-dialog title="修改配送工地" :visible.sync="deliverySiModifyDialog" width="30%" :closeOnClickModal='false' append-to-body custom-class="sales-delivery-place-dialog">
					<div class="customerManagementPC-add-customer">
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">配送地:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="DSNameModify" readonly/>
							</div>
							<div class="customerManagementPC-add-customer-li-type"></div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">配送工地:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="DSDeliveryModify"/>
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">运费:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input style="width: 80%;" type="text" v-model="DSFreightModify" @keyup="DSFreightModifyUp"/>元/吨
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">联系人:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="DSContactsModify"  />
							</div>
							<div class="customerManagementPC-add-customer-li-type"></div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">联系方式:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="DSPhoneModify"  />
							</div>
							<div class="customerManagementPC-add-customer-li-type"></div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">备注:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="DSRemarksModify" />
							</div>
							<div  class="customerManagementPC-add-customer-li-type"></div>
						</div>
						<div class="customerManagementPC-add-customer-btn">
							<el-button type="primary" @click="deliverySiModifySave">保存</el-button>
							<el-button type="info" @click="deliverySiModifyDialog=false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!--  -->
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return {
				userobj: this.$store.state.uobj, //登陆缓存--用户信息
				deliveryPlaceNameQuery:'',
				// options: [{
				// 	value: "",
				// 	label: "全部",
				// }, ],
				// 配送地管理
				deliveryPlaceDialog: false,
				DPcurrentPage:1,
				DPpage: 1,
				DPpagesize: 10,
				DPcount: 1,
				DPList: [],
				// 配送地--新增
				deliveryPlAddDialog: false,
				DPNameAdd: '',//配送地
				DPFreightAdd: '',//运费
				// DPRemarksAdd: '',//备注
				// 配送地--修改
				deliveryPlModifyDialog: false,
				DPNameModify: '',//配送地
				DPFreightModify: '',//运费
				// DPRemarksModify: '',//备注
				// 配送工地管理
				deliverySiteDialog: false,
				DSpage: 1,
				DSpagesize: 10,
				DScount: 1,
				DSList: [],
				// 配送工地--新增
				deliverySiAddDialog: false,
				ORMTB414ID:'',//配送地每条数据ID
				DSNameAdd: '',//配送地
				DSFreightAddMo:'',//配送地运费默认
				DSDeliveryAdd: '',//配送工地名称
				DSFreightAdd:'',//运费
				DSContactsAdd:'',//联系人
				DSPhoneAdd:'',//联系电话
				DSRemarksAdd: '',//备注
				// 配送工地--修改
				deliverySiModifyDialog: false,
				SETTB144ID:'',//配送工地每条数据ID
				DSNameModify: '',//配送地
				DSDeliveryModify: '',//配送工地名称
				DSFreightModify:'',//运费
				DSContactsModify:'',//联系人
				DSPhoneModify:'',//联系电话
				DSRemarksModify: '',//备注
				// 历史缓存
				currentUrl: this.$route.path,
				historyInfo: "",
				solelist: [],
		
			};
		},
		created() {
			var list = "";
			list = this.$store.state.solelist;
			var path = this.$route.path;
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
			this.userobj = this.$store.state.uobj;
			this.historyInfo=JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if(this.historyInfo!=null&&this.historyInfo!=''){
				this.init()
			} 
		},
		beforeDestroy() {
			var obj={
				deliveryPlaceNameQuery:this.deliveryPlaceNameQuery,
				DPcurrentPage:this.DPcurrentPage,
				DPpage:this.DPpage,
				DPpagesize:this.DPpagesize,
			}
			sessionStorage.setItem(this.currentUrl,JSON.stringify(obj))
		},
		mounted() {
			console.log(this.userobj.ormtb410.ORMTB410ID)
			this.DPQuerylist();
		},
		methods:{
			//初始化数据
			init() {
				this.deliveryPlaceNameQuery= this.historyInfo.deliveryPlaceNameQuery;
				this.DPcurrentPage = this.historyInfo.DPcurrentPage;
				this.DPpage = this.historyInfo.DPpage;
				this.DPpagesize = this.historyInfo.DPpagesize;
			},
			// 配送地列表
			DPhandleSizeChange(val) {
				this.DPpage = 1;
				this.DPpagesize = val;
				this.DPQuerylist();
			},
			DPhandleCurrentChange(val) { //当前页
				this.DPpage = val;
				this.DPQuerylist();
			},
			conditionsQuery() {
				//条件查询
				this.DPpage = 1;
				this.DPQuerylist();
			},
			DPQuerylist() {
				this.DPList = []
				var url = "/orm/ormtb414/selectPageList"
				var data = {
					ORMTB414CA00: this.deliveryPlaceNameQuery, //配送地名称
					page: this.DPpage,
					limit: this.DPpagesize
				}
				this.axios.post(url, data).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.DPList = res.data.data
						this.DPcount = res.data.count
					} else {
						this.$message.error(res.data.message);
					}
				})
			},
			// 配送地--新增
			deliveryPlaceAdd() {
				this.deliveryPlAddDialog = true;
				this.DPNameAdd=''
				this.DPFreightAdd=''
				// this.DPRemarksAdd=''
			},
			deliveryPlAddSave(){
				if (this.DPNameAdd=='') return this.$message.error('请输入配送地')
				if (this.DPFreightAdd==='') return this.$message.error('请输入运费')
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB410ID: this.userobj.ormtb410.ORMTB410ID, //
					ORMTB414CA00: this.DPNameAdd, //
					ORMTB414CA01: this.DPFreightAdd, //
					// SETTB143CA03: this.DPRemarksAdd, //备注
				}
				var url = "/orm/ormtb414/insert";
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.$message({
							message: '新增成功',
							type: 'success'
						});
						this.DPQuerylist();
						this.deliveryPlAddDialog = false;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			// 配送地--修改
			DPModifyClick(item){
				this.deliveryPlModifyDialog = true;
				this.DPNameModify=item.ORMTB414CA00
				this.DPFreightModify=item.ORMTB414CA01
				// this.DPRemarksModify=item.SETTB143CA03
				this.ORMTB414ID=item.ORMTB414ID
			},
			deliveryPlModifySave(){
				if (this.DPNameModify=='') return this.$message.error('请输入配送地')
				if (this.DPFreightModify==='') return this.$message.error('请输入运费')
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB414ID:this.ORMTB414ID,
					ORMTB410ID: this.userobj.ormtb410.ORMTB410ID, //id
					ORMTB414CA00: this.DPNameModify, //
					ORMTB414CA01: this.DPFreightModify, //
					// SETTB143CA03: this.DPRemarksModify, //备注
				}
				var url = "/orm/ormtb414/update";
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.DPQuerylist();
						this.deliveryPlModifyDialog = false;
					} else {
						this.$message({
							message: res.data.msg,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			DPDelClick(row){
				this.$confirm('确认删除此配送地吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let loading = this.$loading({
						lock: true,
						text: '请求中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.5)'
					});
				// var postData = {
				// 	SETTB143ID: row.SETTB143ID, //id
				// }
				let url = "/orm/ormtb414/delete/"+row.ORMTB414ID;
				this.axios.get(url).then((res) => {
					console.log(res)
					if (res.data.code == 200) {
						this.DPQuerylist();
					} else {
						this.$message({
							message: res.data.msg,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
						loading.close();
					})
				})
			},
			//配送单价
			DPFreightAddUp() {
				var value = this.DPFreightAdd;
				// this.DPFreightAdd = this.clearNoNum(value);
				var num = this.clearNoNum(value);
				if(num<=0) return
				if(num>100000)
				this.$message.error('单价高于最大限制100000')
				num=num>100000?100000:num
				this.DPFreightAdd=num
			},
			DPFreightModifyUp() {
				var value = this.DPFreightModify;
				// this.DPFreightModify = this.clearNoNum(value);
				var num = this.clearNoNum(value);
				if(num<=0) return
				if(num>100000)
				this.$message.error('单价高于最大限制100000')
				num=num>100000?100000:num
				this.DPFreightModify=num
			},
			// 配送工地--运费
			DSFreightAddUp() {
				var value = this.DSFreightAdd;
				// this.DSFreightAdd = this.clearNoNum(value);
				var num = this.clearNoNum(value);
				if(num<=0) return
				if(num>100000)
				this.$message.error('单价高于最大限制100000')
				num=num>100000?100000:num
				this.DSFreightAdd=num
			},
			DSFreightModifyUp() {
				var value = this.DSFreightModify;
				// this.DSFreightModify = this.clearNoNum(value);
				var num = this.clearNoNum(value);
				if(num<=0) return
				if(num>100000)
				this.$message.error('单价高于最大限制100000')
				num=num>100000?100000:num
				this.DSFreightModify=num
			},
			clearNoNum(value) {
				value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
				if (value.indexOf(".") < 0 && value != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					value = parseFloat(value);
				}
				return value;
			},
			// 配送工地管理
			deliverySiteClick(item){
				this.deliverySiteDialog=true
				this.ORMTB414ID= item.ORMTB414ID
				this.DSQuerylist();
				this.DSNameAdd= item.ORMTB414CA00
				this.DSNameModify= item.ORMTB414CA00
				this.DSFreightAddMo=item.ORMTB414CA01
			},
			// 配送地列表
			DShandleSizeChange(val) {
				this.DSpage = 1;
				this.DSpagesize = val;
				this.DSQuerylist();
			},
			DShandleCurrentChange(val) { //当前页
				this.DSpage = val;
				this.DSQuerylist();
			},
			DSQuerylist() {
				this.DSList = []
				var url = "/orm/ormtb415/selectPageList"
				var data = {
					ORMTB414ID: this.ORMTB414ID,
					page: this.DSpage,
					limit: this.DSpagesize
				}
				this.axios.post(url, data).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.DSList = res.data.data
						this.DScount = res.data.count
					} else {
						this.$message.error(res.data.message);
					}
				})
			},
			// 配送工地--新增
			deliverySiteAdd() {
				this.deliverySiAddDialog = true;
				this.DSDeliveryAdd=''
				this.DSFreightAdd=''
				this.DSFreightAdd=this.DSFreightAddMo
				this.DSContactsAdd=''
				this.DSPhoneAdd=''
				this.DSRemarksAdd=''
			},
			deliverySiAddSave(){
				if (this.DSNameAdd=='') return this.$message.error('请输入配送地')
				if (this.DSDeliveryAdd==='') return this.$message.error('请输入配送工地')
				if (this.DSFreightAdd==='') return this.$message.error('请输入运费')
				 var regP = /^1[3-9][0-9]{9}$/;
				if (this.DSPhoneAdd != '') {
					if (!regP.test(this.DSPhoneAdd)) return this.$message.error("请输入有效手机号");
				}
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB415CA00: this.DSDeliveryAdd, //
					ORMTB415CA01: this.DSFreightAdd, //
					ORMTB414ID: this.ORMTB414ID,
					ORMTB415CA02: this.DSContactsAdd, //
					ORMTB415CA03: this.DSPhoneAdd, //
					ORMTB415CA04: this.DSRemarksAdd, //备注
				}
				var url = "/orm/ormtb415/insert";
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.$message({
							message: '新增成功',
							type: 'success'
						});
						this.DSQuerylist();
						this.deliverySiAddDialog = false;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			// 配送工地--修改
			DSModifyClick(item){
				console.log(item.ORMTB415ID)
				this.deliverySiModifyDialog = true;
				this.DSDeliveryModify=item.ORMTB415CA00
				this.DSFreightModify=item.ORMTB415CA01
				this.ORMTB415ID=item.ORMTB415ID
				this.DSContactsModify=item.ORMTB415CA02||''
				this.DSPhoneModify=item.ORMTB415CA03||''
				this.DSRemarksModify=item.ORMTB415CA04||''
			},
			deliverySiModifySave(){
				if (this.DSNameModify=='') return this.$message.error('请输入配送地')
				if (this.DSDeliveryModify==='') return this.$message.error('请输入配送工地')
				if (this.DSFreightModify==='') return this.$message.error('请输入运费')
				//  var regP = /^1[3-9][0-9]{9}$/;
				// if (this.DSPhoneModify != '') {
				// 	if (!regP.test(this.DSPhoneModify)) return this.$message.error("请输入有效手机号");
				// }
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB415CA00: this.DSDeliveryModify, //
					ORMTB415CA01: this.DSFreightModify, //
					ORMTB414ID: this.ORMTB414ID,
					ORMTB415ID: this.ORMTB415ID,
					ORMTB415CA02: this.DSContactsModify, //
					ORMTB415CA03: this.DSPhoneModify, //
					ORMTB415CA04: this.DSRemarksModify, //备注
				}
				var url = "/orm/ormtb415/update";
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.DSQuerylist();
						this.deliverySiModifyDialog = false;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			DSDelClick(row){
				this.$confirm('确认删除此配送工地吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let loading = this.$loading({
						lock: true,
						text: '请求中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.5)'
					});
				let url = "/orm/ormtb415/delete/"+row.ORMTB415ID;
				this.axios.get(url).then((res) => {
					console.log(res)
					if (res.data.code == 200) {
						this.DSQuerylist();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
						loading.close();
					})
				})
			},
		}
	}
</script>

<style scoped>
	.carDialogTitle {
		font-weight: bold;
		line-height: 60px;
		color: rgb(0, 163, 255);
	}
	.salesDeliveryPlace-input {
		display: flex;
		flex-direction: row;
		align-items: center !important;
	}
	.salesDeliveryPlace-input>input {
		height: 40px;
		box-sizing: border-box;
		border: 1px solid #dcdfe6;
		border-radius: 5px;
		padding-left: 5px;
	}
	.customerManagementPC {
		background-color: #f3f3f3;
	}
	
	.customerManagementPC-select .public_oparetionBlock_Menu:first-child {
		margin-left: 0;
	}
	
	.customerManagementPC-btn {
		text-align: left;
		margin-bottom: 20px;
	}
	
	.customerManagementPC-btn i {
		margin-right: 10px;
	}
	
	.customerManagementPC-table-btn i {
		font-size: 12px;
		margin-right: 5px;
	}
	
	.public-chech-details-table {
		margin-top: 20px;
		max-height: 500px;
		overflow-y: auto;
	}
	
	.public-chech-details-table-no-text {
		line-height: 80px;
		text-align: center;
		border-bottom: 1px solid #cdcdcd;
	}
	
	.customerManagementPC-page {
		margin-top: 20px;
		text-align: right;
	}
	
	.CustomerfillingDig-priceNumtext {
		font-weight: 500;
		font-size: 18px;
		line-height: 40px;
		padding: 20px 0 20px 10px;
		color: #333;
	}
	
	.CustomerfillingDig-priceNumtext span {
		color: rgba(175, 181, 4, 1.0);
		margin-left: 10px;
		font-size: 20px;
	}
	
	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}
	
	.billOperationRecord {
		background-color: #f3f3f3;
	}
	
	.billOperationRecord-border {
	
		/* border-top: 2px solid rgba(205,205,205,.4); */
		border-top: none;
		box-sizing: border-box;
		margin-right: 40px;
	}
	
	.billOperationRecord th,
	.billOperationRecord td {
		text-align: center;
	}
	
	.customerRecharge-table {
		box-sizing: border-box;
	}
	
	.CustomertopUpDig-content-table-btn>.public_saleWater_lieSet {
		border-color: rgba(254, 172, 0, 1) !important;
	}
	
	.rechargeType-tab-btn {
		margin-top: 80px !important;
	}
	
	.billOperationRecord-page {
		padding-right: 40px;
		text-align: right;
		margin-top: 20px;
		padding-bottom: 20px;
	}
	
	.salesWatersStatisticsPC-saleWaterDetails-btn {
		margin-bottom: 20px;
	}
	
	.salesWatersStatisticsPC-saleWaterDetails-btn i {
		margin-right: 10px;
	}
</style>
<style>
.sales-delivery-place-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.sales-delivery-place-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.sales-delivery-place-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.sales-delivery-place-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.sales-delivery-place-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
